import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import classNames from 'classnames';
import { staticText } from '../../../../../utils/staticText';
import { useClientContext } from '../../../../modules/context/client';
import { getClientTranslations } from '../../../../modules/i18n/client.index';
import Button from '../../../Button';

const pictogramSrc =
  'https://mhgprod.blob.core.windows.net/fe-services/content/assets/triangle-attention.png';

const Translations = staticText({
  errorMessage: {
    _: 'Something went wrong',
    'zh-hk': '發生錯誤',
  },
  helpText: {
    _: 'We couldn’t load the results. Please refresh the page to try again.',
    'zh-hk': '無法載入結果，請重新整理後再試。',
  },
  actionText: {
    _: 'Try Again',
    'zh-hk': '再試一次',
  },
});

const style = {
  background:
    'linear-gradient(180deg, var(--highlights-blue-light, #E0F4F8) 0%, var(--highlights-green-light, #E8F5E9) 100%)',
  borderRadius: '50%',
};
const widths = 'md:p-[24px]';

type TIErrorResultProps = {
  onRetry?: () => void;
};

export const TIErrorResult: React.FC<TIErrorResultProps> = ({
  onRetry,
}: TIErrorResultProps) => {
  const context = useClientContext();
  const t = getClientTranslations(Translations, context);

  return (
    <div className="flex flex-col items-center gap-spacing/gap/y rounded-radius/table border border-borders/default p-spacing/padding/section-y bg-fill/card">
      <div className="flex max-w-general/4-col-width flex-col items-center gap-spacing/gap/soft-12px">
        <div
          className={classNames(widths, 'p-spacing/gap/soft-12px')}
          style={style}
        >
          <CmsImage
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="size-[58px] object-cover object-top"
            src={pictogramSrc}
            alt="Attention image"
            aria-hidden
            width={58}
            height={58}
            priority
            unoptimized
          />
        </div>
        <h2 className="mhg-alpha-typography-subheading-1">{t.errorMessage}</h2>
        <div className="mhg-alpha-typography-body-1-relaxed text-center text-colors/neutral-gray-800">
          {t.helpText}
        </div>
      </div>
      <Button type="button" onClick={onRetry}>
        {t.actionText}
      </Button>
    </div>
  );
};
